
import React from "react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Mail, AlertTriangle } from "lucide-react";

interface ResetConfirmationProps {
  type: "sent" | "complete";
  email?: string;
  onDone: () => void;
}

const ResetConfirmation = ({ type, email, onDone }: ResetConfirmationProps) => {
  return (
    <div className="text-center space-y-4">
      <Alert className={type === "sent" ? "bg-blue-50 border-blue-200" : "bg-green-50 border-green-200"}>
        <Mail className={`h-4 w-4 ${type === "sent" ? "text-blue-500" : "text-green-500"} mr-2`} />
        <AlertDescription>
          {type === "sent" ? (
            <>
              <p className="font-semibold">Parooli lähtestamise link on saadetud!</p>
              <p className="mt-1">E-kiri lähtestamislingiga on saadetud aadressile <strong>{email}</strong>.</p>
            </>
          ) : (
            <>
              <p className="font-semibold">Parool on edukalt muudetud!</p>
              <p className="mt-1">Nüüd saad sisse logida oma uue parooliga.</p>
            </>
          )}
        </AlertDescription>
      </Alert>
      
      <Button onClick={onDone} className="mt-6">
        {type === "sent" ? "Tagasi sisselogimise lehele" : "Logi sisse"}
      </Button>
    </div>
  );
};

export default ResetConfirmation;
